import React from "react";
import NavBar from "../Utils/NavBar";
import FootBar from "../Utils/FootBar";
import BackDecoration from "../Utils/BackDecoration";
import { useParams } from "react-router";
import axios from "axios";
import { useState, useEffect } from "react";
import {
  FaFacebook,
  FaWhatsapp,
  FaTimes,
  FaThumbsUp,
  FaShare,
  FaChevronDown,
  FaRegPaperPlane,
} from "react-icons/fa";
import { SpinnerCircular } from "spinners-react";
import DoneMessages from "../Utils/DoneMessage";
import Cookies from "universal-cookie";
import ReactTimeAgo from "react-time-ago";
require("../../assets/stylesheets/Project/Project.css");

const cookie = new Cookies();
var loading = true;
var root = document.location;

function ShowSharePanel({ title, code }) {
  const [viewSharePanel, setSharePanel] = useState(false);
  const [viewMessageCopied, setMessageCopied] = useState(false);

  const [text, setText] = useState("");
  const [statusCode, setStatusCode] = useState(200);
  const [messageView, setMessageView] = useState(false);

  useEffect(() => {}, [viewSharePanel, viewMessageCopied, messageView]);

  const hideSharePanel = () => {
    setSharePanel(false);
    setMessageCopied(false);
  };

  const copyLink = (e) => {
    var link = document.getElementById("link").value;
    console.log(link);
    navigator.clipboard.writeText(link);
    setMessageCopied(true);
    setText("Enlace copiado");
    setStatusCode(200);
    setMessageView(true);
  };

  const handleShareView = () => {
    setSharePanel(true);
    setMessageView(false);
  };

  return (
    <div>
      {messageView && (
        <DoneMessages text={text} code={statusCode} visibility={messageView} />
      )}
      <button className="btnShare" onClick={handleShareView} title="Compartir">
        <FaShare /> Compartir
      </button>
      <div
        className={viewSharePanel ? "showSharePanel" : "hide"}
        onClick={hideSharePanel}
      >
        <div className="sharePanel">
          <div className="shareHeader">
            <p>
              {" "}
              <strong>Compartir</strong>{" "}
            </p>
            <div className="btnClose" onClick={hideSharePanel}>
              <FaTimes />
            </div>
          </div>
          <div>{title}</div>
          <div className="shareSNS">
            <a
              href={
                `whatsapp://send?text=Ven%20y%20apoya%20mi%20proyecto%20en%20la%20Feria%20Ingenio%20de%20la%20Universidad%20Tecnológica%20de%20Honduras%20` +
                root
              }
              target="_blank"
              className="shareWhatsapp"
            >
              <FaWhatsapp />
            </a>
            <a
              href={`https://www.facebook.com/sharer/sharer.php?u=` + root}
              target="_blank"
              className="shareFacebook"
            >
              <FaFacebook />
            </a>
          </div>
          <div className="clipBoard">
            <input type="text" value={root} disabled id="link" />
            <div
              className={viewMessageCopied ? "btnCopied" : "btnCopy"}
              onClick={(e) => copyLink(e)}
            >
              {viewMessageCopied ? "Copiado" : "Copiar"}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const UserLogged = () => {
  return (
    <div className="nonLog">
      <p>Tienes que iniciar sesión para poder votar o comentar.</p>
      <a href="/signin">Inicia Sesión Aquí</a>
    </div>
  );
};

function ProjectPanel() {
  const [summaryView, setSummaryView] = useState(false);
  const [data, setData] = useState({});
  const [dataComment, setDataComment] = useState([]);
  const params = useParams();
  const [userAlert, setUserAlert] = useState(false);

  const [text, setText] = useState("");
  const [statusCode, setStatusCode] = useState(200);
  const [messageView, setMessageView] = useState(false);
  const [user, setUser] = useState({});
  const [likes, setLikes] = useState(0);

  const [commentContent, setCommentContent] = useState({
    comment: "",
  });

  useEffect(() => {
    axios
      .post(
        "https://ferias-ingenio-backend.vercel.app/api/projects/getproject",
        {code: params.code}
      )
      .then((res) => {
        setData(res.data[0]);
        console.log(res.data[0]);
        setDataComment(res.data[0].comments);
        setLikes(res.data[0].likes);
        loading = false;
      })
      .catch((err) => {
        console.log(err);
      });
  }, [summaryView, userAlert, messageView]);

  let projectUrl = "https://www.youtube.com/embed/" + params.code;

  const summary = () => {
    setSummaryView((current) => !current);
  };

  const setLike = async () => {
    await axios
      .post("https://ferias-ingenio-backend.vercel.app/api/users/getlikesuser", {
        username: cookie.get("username"),
      })
      .then((res) => {
        setUser(res.data);
      });

    setMessageView(false);
    setUserAlert(false);
    if (cookie.get("username") == undefined) {
      setUserAlert(true);
    } else if (user.likes.includes(data.idCategory)) {
      setMessageView(true);
      setText("Ya has votado en esta categoría");
      setStatusCode(400);
    } else {
      axios
        .post(
          "https://ferias-ingenio-backend.vercel.app/api/projects/setlike",
          {
            code: params.code,
          }
        )
        .then((res) => {
          setLikes(res.data.likes);
          setMessageView(true);
          setText("Ahora estas apoyando este proyecto :)");
          setStatusCode(200);
        })
        .catch((err) => {
          console.log(err);
        });

      axios
        .post(
          "https://ferias-ingenio-backend.vercel.app/api/projects/setuserlike",
          {
            code: data.idCategory,
            id: cookie.get("id"),
          }
        )
        .then((res) => {})
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const sendComment = () => {
    setMessageView(false);
    setUserAlert(false);
    if (commentContent.comment.length > 0) {
      if (cookie.get("username") != undefined) {
        axios
          .post(
            "https://ferias-ingenio-backend.vercel.app/api/projects/setcomment",
            {
              code: params.code,
              comment: commentContent.comment,
              date: Date.now(),
              username: cookie.get("username"),
            }
          )
          .then((res) => {
            setCommentContent({
              comment: "",
            });
            setDataComment([]);
            setDataComment(res.data.comments);
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        setUserAlert(true);
      }
    } else {
      setMessageView(true);
      setText("Comentario Vacío");
      setStatusCode(400);
    }
  };

  return (
    <div className="projectSection">
      {loading && <SpinnerCircular secondaryColor="#fff" />}
      {userAlert && <UserLogged />}
      {messageView && (
        <DoneMessages text={text} code={statusCode} visibility={messageView} />
      )}
      <div className="projectView">
        <div className="videoProject">
          <iframe
            width="100%"
            height="100%"
            src={projectUrl}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
        <div className="projectOptions">
          <div className="titleProject">{data.title}</div>
          <div className="projectBtn">
            <div className="likes" onClick={setLike}>
              <FaThumbsUp title="Apoyo este proyecto" />
              {likes}
            </div>
            <ShowSharePanel title={data.title} code={data.code} />
            <span onClick={summary}>
              <FaChevronDown /> Descripción
            </span>
            <span>
              {" "}
              <a href={`/categories/${data.idCategory}/${data.categoryName}`}>
                Más Proyectos
              </a>{" "}
            </span>
          </div>
          <div className={summaryView ? "projectInfo" : "hide"}>
            <hr />
            <p>
              <span>Proyecto de: </span>{" "}
              {data.payRegister == "0" ? "Exibición" : "Competencia"}
            </p>
            <p>
              <span>Descripción: </span> {data.description}
            </p>
            <p>
              <span>Clase: </span> {data.matter}
            </p>
            <p>
              <span>Categoria: </span> {data.categoryName}
            </p>
            <p>
              <span>Coodinador {`(a)`}: </span> {data.coordinator}
            </p>
            <p>
              <span>Equipo: </span> <textarea value={data.team}></textarea>
            </p>
            <p>
              <span>Catedratic@: </span> {data.master}
            </p>
          </div>
        </div>
      </div>

      <div className="projectCom">
        <div className="commentsContainer">
          {Object.values(dataComment).map((e) => {
            return (
              <div className="comment">
                <div className="comment-header">
                  <p className="comment-user">{e.user}</p>
                  <p className="comment-date">
                    <ReactTimeAgo date={e.date} locale="en-US" />
                  </p>
                </div>
                <div className="comment-body">{e.comment}</div>
              </div>
            );
          })}
        </div>
        <div className="commentInput">
          <input
            type="text"
            placeholder="Comenta tú opinión"
            value={commentContent.comment}
            onChange={(e) => {
              setCommentContent({ ...commentContent, comment: e.target.value });
            }}
          />
          <button onClick={sendComment}>
            <FaRegPaperPlane />
          </button>
        </div>
      </div>
    </div>
  );
}

function Project() {
  return (
    <div className="inpages">
      <NavBar />
      <BackDecoration />
      <ProjectPanel />
    </div>
  );
}

export default Project;
